import { useField, useFormikContext } from 'formik';
import React from 'react';
import { Form as BulmaForm } from '@codeparva/ui-components-library';
import { FormFieldsTypes } from './FormFieldsTypes';
import { getAsterisk } from './helper/GetAstrisk';
import { GetErrorMessageIcon } from './helper/GetErrorMessageIcon';
import addDays from 'date-fns/addDays';
import { useSectionData } from '../../sections/rentalPage/components/dynamicForm/hooks/dataContext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { isValid, parse } from 'date-fns';

const DatePickerComponent = ({ ...props }: any) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  const handleDateChange = (event: any) => {
    if (event.nativeEvent.inputType === 'insertText') {
      const dateStr = event.currentTarget.value.replace(/[^0-9]/g, ''); // Remove any non-digit characters
      let formattedDateStr;

      if (dateStr.length === 8) {
        // If the date string is 8 characters long, it is already in the 'MMddyyyy' format
        formattedDateStr = dateStr;
      } else if (dateStr.length === 7) {
        // If the date string is 7 characters long, we need to determine whether the month or day is a single digit
        if (dateStr.charAt(0) === '1' || dateStr.charAt(0) === '0') {
          const month = dateStr.substring(0, 1);
          const day = dateStr.substring(1, 3);
          const year = dateStr.substring(3);
          formattedDateStr = `0${month}${day}${year}`;
        } else {
          const month = dateStr.substring(0, 2);
          const day = dateStr.substring(2, 3);
          const year = dateStr.substring(3);
          formattedDateStr = `${month}0${day}${year}`;
        }
      } else {
        // If the date string is not 8 or 7 characters long, it is not a valid date
        console.log('Invalid date string:', dateStr);
        return;
      }

      const parsedDate = parse(formattedDateStr, 'MMddyyyy', new Date());

      if (parsedDate && !isNaN(parsedDate.getTime()) && isValid(parsedDate)) {
        setFieldValue(field.name, parsedDate);
      } else {
        console.log('Parsed date is not valid');
      }
    }
  };
  return (
    <DatePicker
      {...field}
      {...props}
      selected={(field.value && new Date(field.value)) || null}
      onChangeRaw={handleDateChange}
      onChange={val => {
        setFieldValue(field.name, val);
      }}
      showYearDropdown
      showMonthDropdown
      scrollableYearDropdown
      peekNextMonth
      dropdownMode="select"
    />
  );
};
export const DatePickerField = ({
  label,
  required,
  name,
}: FormFieldsTypes.IDatePickerField) => {
  let { errors }: any = useFormikContext();
  const { maxDaysBeforeMoveIn } = useSectionData();
  const { Input } = BulmaForm;

  const maxDate = addDays(new Date(), maxDaysBeforeMoveIn);
  const minDate = new Date();

  return (
    <>
      <label>
        {label}
        {required === true && getAsterisk()}
      </label>

      <DatePickerComponent
        type="date"
        name={name}
        className="input"
        id={name}
        minDate={label.includes('Desired Move-In') ? minDate : null}
        maxDate={label.includes('Desired Move-In') ? maxDate : null}
        as={Input}
      />

      {errors[name] ? (
        <div className="ErrorMessage is-flex is-align-items-center">
          {GetErrorMessageIcon()}
          {errors[name]}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
